import {
  addEntryToShortlist as addEntryToShortlistServer,
  removeEntryFromShortlist as removeEntryFromShortlistServer,
  updateEntryRankInShortlist as updateEntryRankInShortlistServer,
  getExistingShortlistEntry as getExistingShortlistEntryServer,
} from '@/actions/shortlistEntries';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const getExistingShortlistEntry = async (shortlistId: string, tenderIds: string[]) => {
  const userAccessToken = await getUserAccessToken();
  return getExistingShortlistEntryServer(userAccessToken, shortlistId, tenderIds);
};

export const addEntryToShortlist = async (shortlistId: string, tenderId: string) => {
  const userAccessToken = await getUserAccessToken();
  return addEntryToShortlistServer(userAccessToken, shortlistId, tenderId);
};

export const updateEntryRankInShortlist = async (shortlistEntryId: string, rank: number) => {
  const userAccessToken = await getUserAccessToken();
  return updateEntryRankInShortlistServer(userAccessToken, shortlistEntryId, rank);
};

export const removeEntryFromShortlist = async (shortlistEntryId: string) => {
  const userAccessToken = await getUserAccessToken();
  return removeEntryFromShortlistServer(userAccessToken, shortlistEntryId);
};
